import request from '@/libs/request';
export const getAppListApi = (data) => request('ListAppBusiness', data);
export const getAppDetailApi = (data) => request('GetAppDetail', data);
export const getAppDetailByAppIDApi = (data) => request('GetAppDetailByAppID', data);
export const updateAppInfoStatusApi = (data) => request('UpdateAppStatus', data);
export const getManagerListApi = (data) => request('GetManagerList', data);
export const updateManagerStatusApi = (data) => request('UpdateManagerStatus', data);
export const addManagerInfoApi = (data) => request('CreateManagerInfo', data);
export const getAppManagerCountApi = (data) => request('GetManagerCount', data);
export const GetManagerInfoByAppOrAgentId = (data) => request('GetManagerInfoByAppOrAgentId', data);
export const getAppListByRoleApi = (data) => request('getAppListByRoleA', data);
export const getManagerInfoApi = (data) => request('GetManagerDetail', data);
export const getAuthURLApi = (data) => request('GetAuthURL', data);
export const updateManagerInfoApi = (data) => request('UpdateManagerInfo', data);
export const GetManagerUserGroup = (data) => request('GetManagerUserGroup', data);
export const getAppUserCountApi = (data) => request('GetAppUserCount', data); // 获取公众号人数
export const getPublishedAppListApi = (data) => request('GetPublishedAppList', data); // 获取已经发布的公众号列表

// 外部应用接口
export const UpdateLinkAppInfoApi = (data) => request('UpdateLinkAppInfo', data);
export const GetLinkAppDetailApi = (data) => request('GetLinkAppDetail', data);
export const GetLinkAppInfoListApi = (data) => request('GetLinkAppInfoList', data);
export const CreateLinkAppInfoApi = (data) => request('CreateLinkAppInfo', data);
export const UpdateLinkAppOrderApi = (data) => request('UpdateLinkAppOrder', data);
export const DeleteLinkAppInfoApi = (data) => request('DeleteLinkAppInfo', data);
// 策略接口
export const getStrategyList = (data = {}) => request('GetStrategyList', data);
export const GetStrategyListByAppID = (data = {}) => request('GetStrategyListByAppID', data);
export const getStrategyDetail = (data = {}) => request('GetStrategyDetail', data);
export const updateStrategyStatus = (data = {}) => request('UpdateStrategyStatus', data);
export const updateStrategyInfo = (data = {}) => request('UpdateStrategyInfo', data);
export const CreateStrategyInfo = (data = {}) => request('CreateStrategyInfo', data);
export const DeleteStrategyInfo = (data = {}) => request('DeleteStrategyInfo', data);
/** 企业设置 */
/* 获取领域列表 */
export const getDomainInfoListApi = (data = {}) => request('GetDomainInfoList', data);

/** 标签设置 */
// 标签设置-产品疾病其他
export const UpdateLabelStatus = (data) => request('UpdateLabelStatus', data); // 修改标签状态
export const UpdateLabelInfo = (data) => request('UpdateLabelInfo', data); // 修改标签
export const GetLabelDetail = (data) => request('GetLabelDetail', data); // 标签详情
export const GetLabelInfoList = (data) => request('GetLabelInfoList', data); // 设置标签列表
export const CreateLabelInfo = (data) => request('CreateLabelInfo', data); // 添加标签

export const CreateLabelClass = (data) => request('CreateLabelClass', data); // 新增标签分类
export const RenameLabelClass = (data) => request('RenameLabelClass', data); // 重命名自定义标签分类名称
export const GetLabelClass = (data) => request('GetLabelClass', data); // 查询标签分类列表
export const DeleteLabelClass = (data) => request('DeleteLabelClass', data); // 删除自定义标签分类

// 标签设置-品牌标签
export const GetBuInfoList = (data) => request('GetBuInfoList', data); // 获取Bu列表
export const UpdateBuInfo = (data) => request('UpdateBuInfo', data); // 修改Bu
export const CreateBuInfo = (data) => request('CreateBuInfo', data); // 添加Bu
export const UpdateBuOrder = (data) => request('UpdateBuOrder', data); // 修改Bu顺序
export const GetDomainInfoList = (data) => request('GetDomainInfoList', data); // 获取Domain列表
export const UpdateDomainInfo = (data) => request('UpdateDomainInfo', data); // 修改Domain
export const CreateDomainInfo = (data) => request('CreateDomainInfo', data); // 添加Domain
export const UpdateDomainOrder = (data) => request('UpdateDomainOrder', data); // 修改Domain顺序
export const GetProductInfoList = (data) => request('GetProductInfoList', data); // 获取Product列表
export const UpdateProductInfo = (data) => request('UpdateProductInfo', data); // 修改Product
export const CreateProductInfo = (data) => request('CreateProductInfo', data); // 添加Product
export const UpdateProductOrder = (data) => request('UpdateProductOrder', data); // 修改Product顺序
// 企业设置接口
export const GetCompanyInfo = (data) => request('GetCompanyInfo', data); // 获取药企基本信息
export const SaveCompanyInfo = (data) => request('SaveCompanyInfo', data); // 保存药企信息
// 会议设置接口
export const GetMeetingConfig = (data) => request('GetMeetingConfig', data); // 获取药企下所有策略
export const SaveMeetingConfig = (data) => request('SaveMeetingConfig', data); // 保存药企下所有策略

// 企业微信管理
export const getAgentManagementApi = (data) => request('GetWecomConfig', data);
export const updateAgentManagementApi = (data) => request('SaveWecomConfig', data);

// 注册认证设置接口
export const getRegisterAuthConfig = (data) => request('GetRegisterAuthConfig', data);
export const setRegisterAuthConfig = (data) => request('SetRegisterAuthConfig', data);
